// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1>Cancel Next Payment</h1>
        </div>
        <div class="hoa-dialog__main">
            <p>Are you sure you want to cancel the payment scheduled on {{data.paymentDate}} for {{data.paymentAmount | currency}} ?</p>
        </div>
        <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <button tid="cancelPaymentNoButton"
                    id="cancelPaymentNoButton"
                    class="Button Button--link Button--minWidth130"
                    (click)="closeThisDialog(0)">
                No
            </button>
            <button tid="cancelPaymentYesButton"
                    id="cancelPaymentYesButton"
                    class="Button Button--blue Button--minWidth130"
                    (click)="closeThisDialog('Cancel')">
                Yes
            </button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;